<div class="review-tab-container">
  <div class="mb-2">
    <p-panel
      header="Homebound Details"
      [togglable]="true"
      toggler="header"
      [collapsed]="false"
      >
      <ng-template #headericons let-collapsed>
        <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
      </ng-template>
      <div class="flex flex-col gap-4 p-formgrid p-fluid p-form-widget p-form-view-data">
        <div class="px-2 w-full">
          <div class="field">
            <label>Does the member's status meet CMS definition of homebound?: </label>
            <div class="p-field-value">
              <div class="readonly-field">
                {{ authRequest.authorizationDTO?.isHomebound ? 'Member is Homebound' : 'Member is not Homebound' }}
              </div>
            </div>
          </div>
        </div>
        <div class="px-2 w-full">
          <div class="field">
            <label>Is there an able/willing/teachable caregiver?: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO?.familyFriendsAssistngWithCareYesResponse | titlecase }}</div>
            </div>
          </div>
        </div>
        @if (authRequest.authorizationDTO.familyFriendsAssistngWithCareYesResponse === 'yes') {
          <div
            class="px-2 w-full"
            >
            <div class="field">
              <label>Enter Caregiver Details: </label>
              @if (!showCareDetailsInMultiline()) {
                <div class="p-field-value">
                  <div class="readonly-field">
                    {{ authRequest.authorizationDTO?.familyOrFriendsAssistingWithCare }}
                    @if (showCareDetailsInMultiline()) {
                      <div
                        style="white-space: pre-line"
                        >
                        {{ authRequest.authorizationDTO?.familyOrFriendsAssistingWithCare }}
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </p-panel>
  </div>
  <div class="mb-2">
    <p-panel
      header="Authorization Details"
      [togglable]="true"
      toggler="header"
      [collapsed]="isPASCompleteFlow"
      >
      <ng-template #headericons let-collapsed>
        <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
      </ng-template>
      <div class="grid grid-cols-12 gap-4 p-formgrid p-fluid p-form-widget p-form-view-data">
        <div class="col-span-12 lg:col-span-6">
          <div class="field">
            <label>Type of Order: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO.orderType }}</div>
            </div>
          </div>
          <div class="field">
            <label>Subtype of Order: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO.orderSubType }}</div>
            </div>
          </div>
          <div class="field">
            <label>Urgency: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO.urgency }}</div>
            </div>
          </div>
          <div class="field">
            <label>Referral Source: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO.referralSource }}</div>
            </div>
          </div>
          <div class="field">
            <label>Referring Facility: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO.referralName }}</div>
            </div>
          </div>
          <div class="field">
            <label>Referring Facility NPI: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO.referringFacilityNPI }}</div>
            </div>
          </div>
        </div>
        <div class="col-span-12 lg:col-span-6">
          <div class="field">
            <label>Facility Discharge Date: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO.facilityDischargeDate | date: 'MM/dd/yyyy' }}</div>
            </div>
          </div>
          <div class="field">
            <label>Requestor: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO.requestorName }}</div>
            </div>
          </div>
          @if (!isExternalUser) {
            <div class="field">
              <label>Request Source: </label>
              <div class="p-field-value">
                <div class="readonly-field">{{ authRequest.authorizationDTO.requestSource }}</div>
              </div>
            </div>
          }
          @if (!isExternalUser) {
            <div class="field">
              <label>Initial Request Received Date: </label>
              <div class="p-field-span-container">
                <span>{{ authRequest.authorizationDTO.dateTimeFaxReceived | utcToLocal: 'MM/dd/yyyy' }}</span>
              </div>
              <label style="margin-left: 24px">Time: </label>
              <div class="p-field-span-container">
                <span>{{ authRequest.authorizationDTO.dateTimeFaxReceived | utcToLocal: 'hh:mm:ss a' }}</span>
              </div>
            </div>
          }
          <div class="field">
            <label>Start of Care Date: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO.startOfCareDate | date:'MM/dd/yyyy' }}</div>
            </div>
          </div>
          <div class="field">
            <label>Cert Period: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ certPeriodRange }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--Immediate Contact Details Start-->
      <div class="mb-2">
        <p-panel
          header="Immediate Contact Details"
          [togglable]="true"
          toggler="header"
          [collapsed]="false"
          >
          <ng-template #headericons let-collapsed>
            <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
          </ng-template>
          <div class="grid grid-cols-12 gap-4 p-formgrid p-fluid p-form-widget p-form-view-data">
            <div class="col-span-6 field">
              <label>Contact Name: </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ (authRequest.authorizationDTO.contactName) || '--'}}
                </div>
              </div>
            </div>
            <div class="col-span-6 field">
              <label>Contact Phone: </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ (authRequest.authorizationDTO.phone) || '--' | phoneNumber}}
                </div>
              </div>
            </div>
            <div class="col-span-6 field">
              <label>Contact Fax: </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ (authRequest.authorizationDTO.fax) || '--' | phoneNumber}}
                </div>
              </div>
            </div>
            <div class="col-span-6 field">
              <label>Contact Phone Extension: </label>
              <div class="p-field-value">
                <div class="readonly-field">
                  {{ (authRequest.authorizationDTO.phoneExt) || '--'}}
                </div>
              </div>
            </div>
          </div>
        </p-panel>
      </div>
      <!--Additional Contact Details End-->
    </p-panel>
  </div>
  <div class="mb-2">
    <p-panel
      header="Diagnosis Details"
      [togglable]="true"
      toggler="header"
      [collapsed]="isPASCompleteFlow"
      >
      <ng-template #headericons let-collapsed>
        <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
      </ng-template>
      @if (showPDGMWarning && !isPASCompleteFlow) {
        <div class="error pdgm-warning">
          {{ primaryICDisNotPDGM }}
        </div>
      }
      <p-table [value]="authorizationIcdDTOs">
        <ng-template pTemplate="header">
          <tr>
            <th scope="col">Diagnosis</th>
            <th scope="col">ICD 10 Code</th>
            <th scope="col">ICD 10 Description</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-icd let-rowIndex="rowIndex">
          @if (icd.icdCodeDTO) {
            <tr>
              <td>{{ icd.icdorderType }}</td>
              <td>
                {{ icd.icdCodeDTO.code }}
                {{ icd.icdCodeDTO.pdgm === true ? ' (PDGM)' : '' }}
              </td>
              <td>
                <span class="truncate" [pTooltip]="icd.icdCodeDTO.description" tooltipPosition="left"
                  tooltipStyleClass="tooltip-xl-size">
                  {{ icd.icdCodeDTO.description }}
                </span>
              </td>
            </tr>
          }
        </ng-template>
      </p-table>
    </p-panel>
  </div>
  <div class="mb-2">
    <p-panel
      header="Service Provider Details"
      [togglable]="true"
      toggler="header"
      [collapsed]="isPASCompleteFlow"
      >
      <ng-template #headericons let-collapsed>
        <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
      </ng-template>
      @if (isExternalUser) {
        <div class="grid grid-cols-12 gap-4 p-formgrid p-fluid p-form-widget p-form-view-data">
          <div class="col-span-12 field">
            <label>Are you accepting care?:</label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationDTO.isAcceptingCare ? 'Yes' : 'No' }}</div>
            </div>
          </div>
          @if (!authRequest.authorizationDTO.isAcceptingCare) {
            <div class="col-span-12 field">
              <label>Have you arranged for another agency?: </label>
              <div class="p-field-value">
                <div class="readonly-field">{{ arrangeForAnotherAgency ? 'Yes' : 'No' }}</div>
              </div>
            </div>
          }
        </div>
      }
      @if (!isExternalUser || authRequest.authorizationDTO.isAcceptingCare || arrangeForAnotherAgency) {
        <div class="flex justify-between items-center mb-4">
          @if (serviceProvider) {
            <span
              class="font-semibold"
              >{{serviceProvider?.providerAccountDTO?.providerName || ''}}
            </span>
          }
        </div>
        <app-service-provider
          [tenantId]="tenantId"
          [tenantName]="tenantName"
          [showHistoryTable]="false"
          [provider]="serviceProvider"
          [serviceLocationDTO]="serviceLocationDTO"
          [isExternalUser]="isExternalUser"
          [reviewMode]="true"
          >
        </app-service-provider>
      }
    </p-panel>
  </div>
  <div class="mb-2">
    <p-panel
      header="Ordering Provider Details"
      [togglable]="true"
      toggler="header"
      [collapsed]="isPASCompleteFlow"
      >
      <ng-template #headericons let-collapsed>
        <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
      </ng-template>
      <div class="flex justify-between items-center mb-4">
        @if (orderingPhysician) {
          <span
            class="font-semibold"
            >{{orderingPhysician?.physicianAccountDTO?.accountName || ''}}
          </span>
        }
        @if (orderingPhysicianNew && !isPASCompleteFlow) {
          <span
            class="font-semibold"
          >{{orderingPhysicianNew?.firstName || '' + ' ' + orderingPhysicianNew?.lastName || ''}}</span>
        } @else {
          <span class="font-semibold">{{orderingPhysicianNew?.accountName}}</span>
        }
      </div>
      <app-physician-provider
        [physician]="orderingPhysician"
        [physicianNew]="orderingPhysicianNew"
        [physicianType]="'Ordering'"
        [isExternalUser]="isExternalUser"
        >
      </app-physician-provider>
    </p-panel>
  </div>
  <div class="mb-2">
    <p-panel
      header="Service Line Details"
      [togglable]="true"
      toggler="header"
      [collapsed]="isPASCompleteFlow"
      >
      <ng-template #headericons let-collapsed>
        <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
      </ng-template>
      @if (authRequest.authorizationCertPeriodDTOs && authRequest.authorizationCertPeriodDTOs.length > 0) {
        <div class="p-form-widget p-form-view-data"
          >
          <div class="field">
            <label>HIPPS code: </label>
            <div class="p-field-value">
              <div class="readonly-field">{{ authRequest.authorizationCertPeriodDTOs[0].hippscode }}</div>
            </div>
          </div>
        </div>
      }
      <p-table [value]="authRequest.authorizationDetailDTOs">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 10rem" scope="col">Date/Time Request Received</th>
            <th scope="col">Skill</th>
            <th scope="col">Status</th>
            <th scope="col">Urgency</th>
            <th scope="col">Visits</th>
            <th scope="col">Service Type</th>
            <th scope="col">Effective From</th>
            @if (!isHH30DayReviewPeriods) {
              <th scope="col">Effective Thru</th>
            }
            @if (isHH30DayReviewPeriods) {
              <th scope="col">Effective To</th>
            }
            <th scope="col">Start of Care</th>
            <th scope="col">Cert Period</th>
            @if (isHH30DayReviewPeriods) {
              <th scope="col">Review Period</th>
            }
            @if (isExternalUser) {
              <th scope="col">Additional Comments</th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-serviceLine>
          <tr>
            <!--
            START comment related CH 256303
            This block should be rewrite as simple tag TD with date in appropriate format and pipe
            and this comment together with comments in this block should be removed with 256303.
            -->
            <!-- utcToLocal pipe stopped working, - 203788 and 255420, issue with dateTimeFaxRecieved format -->
            @if (!isPASCompleteFlow) {
              <td
              >{{ serviceLine.dateTimeFaxRecieved | date: 'MM/dd/yyyy hh:mm:ss a'}}</td>
            } @else {
              <td>{{ serviceLine.dateTimeFaxRecieved | utcToLocal: 'MM/dd/yyyy hh:mm:ss a'}}</td>
            }
            <!-- utcToLocal pipe works for PASCompleteFlow, - 253735, issue with dateTimeFaxRecieved format -->
            <!-- END comment related CH 256303 -->
            <td
              pTooltip="{{serviceLine.hcpccode}}"
              tooltipPosition="bottom"
            >{{ serviceLine.skillCode | skillCode }}</td>
            <td>{{ serviceLine.serviceStatus }}</td>
            <td>{{ serviceLine.urgency }}</td>
            <td>{{ serviceLine.requestedAmount }}</td>
            <td>{{ serviceLine.requestType }}</td>
            <td>{{ serviceLine.effectiveFromDate | date: 'MM/dd/yyyy' }}</td>
            <td>{{ serviceLine.effectiveToDate | date: 'MM/dd/yyyy' }}</td>
            <td>{{ authRequest.authorizationDTO.startOfCareDate | date:'MM/dd/yyyy' }}</td>
            @if (!isHH30DayReviewPeriods) {
              <td>{{ serviceLine.certPeriod }}</td>
            }
            @if (isHH30DayReviewPeriods) {
              <td [pTooltip]="certPeriodRange" tooltipPosition="bottom">
                <span class="content">{{ serviceLine.certPeriod }}</span>
                <span class="icon"><i class="pi pi-exclamation-circle"></i></span>
              </td>
              @if (getReviewPeriodDetails(serviceLine.reviewPeriodType, serviceLine.certPeriod); as details) {
                <td [pTooltip]="details.dateRange" tooltipPosition="bottom">
                  <span class="content">
                    {{ details.type}}
                  </span>
                  @if (details.showIcon) {
                    <span class="icon">
                      <i class="pi pi-exclamation-circle"></i>
                    </span>
                  }
                </td>
              }
            }
            @if (isExternalUser) {
              <td>
                <span pTooltip="{{serviceLine.additionalComments}}" tooltipPosition="bottom">
                  {{ serviceLine.additionalComments?.length > 30 ? (serviceLine.additionalComments | slice:0:30) + '...' :
                  serviceLine.additionalComments || '--' }}
                </span>
              </td>
            }
          </tr>
        </ng-template>
      </p-table>
    </p-panel>
  </div>
  <div class="mb-2">
    <p-panel
      header="Documents Details"
      [togglable]="true"
      toggler="header"
      [collapsed]="false"
      >
      <ng-template #headericons let-collapsed>
        <i class="pi pi-chevron-down duration-150" [class]="{ 'rotate-180': !collapsed }"></i>
      </ng-template>
      @if (!isPASCompleteFlow) {
        <div class="p-fluid p-form-widget p-form-view-data">
          <div class="field">
            <label>Are you uploading an OASIS with your request?:</label>
            <div class="p-field-value">
              <div class="readonly-field">{{ documentsTabInfo.uploadOasis }}</div>
            </div>
          </div>
        </div>
        @if (authRequest.authorizationDTO.hasMissingDocument) {
          <div class="mt-6 mb-8 field">
            <p-checkbox [(ngModel)]="authRequest.authorizationDTO.hasMissingDocument" [disabled]="true" [binary]="true">
            </p-checkbox>
            <label class="ml-4 mb-0">I do not have any of these</label>
          </div>
        }
        @if (documentsTabInfo.historyAndPhysical) {
          <div class="mt-6 mb-8 field">
            <p-checkbox [ngModel]="true" [disabled]="true" [binary]="true"></p-checkbox>
            <label class="ml-4 mb-0">Clinical Documentation</label>
          </div>
        }
      }

      @if (documentsTabInfo.signedVerbalOrderDate) {
        <div class="field mt-2 mb-0">
          <label>Order Type: </label>
          {{ documentsTabInfo.dateType === 'signedOrder' ? 'Signed Order' : 'Verbal Order' }}
          <label class="ml-12">Date: </label>
          {{ documentsTabInfo.signedVerbalOrderDate | date: 'MM/dd/yyyy' }}
          @if (documentsTabInfo.dateType === 'verbalOrder' && isPASCompleteFlow) {
            <span class="field mt-2 ml-12 mb-0">
              <label>Ordering Physician Name: </label>
              {{ documentsTabInfo.verbalOrderingPhysician }}
            </span>
          }
        </div>
      }

      @if (documents.length > 0 && !isPASCompleteFlow) {
        <div class="upload-container">
          <p-table [value]="documents" responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th scope="col" style="width: 15rem">File Name</th>
                <th scope="col" style="width: 17rem">Document Type</th>
                <th scope="col" style="width: 11rem">Description</th>
                <th scope="col" style="width: 3rem">File Size</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-file>
              <tr>
                <td style="width: 15rem">{{ file.documentFileName }}</td>
                <td style="max-width: 17rem">
                  <span class="truncate" [pTooltip]="file.documentTypes && file.documentTypes.join(', ')" tooltipStyleClass="tooltip-xl-size">
                    {{ file.documentTypes && file.documentTypes.join(', ') }}
                  </span>
                </td>
                <td style="width: 11rem">{{ file.description }}</td>
                <td style="width: 3rem">{{ file.fileMetaData.size }} Bytes</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </p-panel>
  </div>
</div>
